import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=677414c3&scoped=true&"
import script from "./ReviewDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=677414c3&prod&lang=scss&scoped=true&"
import style1 from "./ReviewDetails.vue?vue&type=style&index=1&id=677414c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677414c3",
  null
  
)

export default component.exports